import Vue from 'vue'
import VueI18n from 'vue-i18n'


Vue.use(VueI18n);


// lingua di default caricata in avvio
import enTT from './assets/lang/en-TT'

const globalLanguages = new VueI18n({
    locale: 'en-TT',
    fallbackLocale: 'en-TT',
    messages: {
        'en-TT': enTT
    }
});


// Funzione privata di adattamento della lingua nei componenti in gestione all'applicazione (app di 1° livello)
function setI18nLanguage(currentCultureCode) {
    globalLanguages.locale = currentCultureCode;
    return currentCultureCode;
}

const loadedLanguages = ['en-TT'];


// Funzione asincrona pubblica per l'impostazione della lingua.
// Questa funzione di occupa anche del caricamento asincrono dei file corrisponenti alle traduzioni
export function loadLanguageAsync(currentCulture) {
    if (!currentCulture) return Promise.resolve(setI18nLanguage('en-TT'));

    const code = currentCulture.code;

    if (globalLanguages.locale === code) return Promise.resolve(currentCulture);
    if (loadedLanguages.includes(code))
        return Promise.resolve(setI18nLanguage(code));

    return import(/* webpackChunkName: "lang-[request]" */ `./assets/lang/${code}`).then(msgs => {
        globalLanguages.setLocaleMessage(code, msgs.default);
        loadedLanguages.push(code);
        return setI18nLanguage(code);
    })
}


// esportazione oggetto globalLanguages (VueI18n instance)
export default globalLanguages;